import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiCalendar, FiAlertTriangle, FiArrowRight } = FiIcons;

const DueTasksNotification = ({ tasks, setCurrentProjectId, setFilter }) => {
  const [visible, setVisible] = React.useState(false);
  const [dueToday, setDueToday] = React.useState([]);
  const [overdue, setOverdue] = React.useState([]);
  const navigate = useNavigate();

  React.useEffect(() => {
    const today = new Date();
    const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);

    const due = [];
    const late = [];
    tasks.forEach(task => {
      if (!task.completed && task.dueDate) {
        const dueDate = new Date(task.dueDate);
        if (dueDate >= startOfDay && dueDate <= endOfDay) {
          due.push(task);
        } else if (dueDate < startOfDay) {
          late.push(task);
        }
      }
    });

    setDueToday(due);
    setOverdue(late);
    setVisible(due.length > 0 || late.length > 0);
  }, [tasks]);

  const openTask = (task) => {
    setCurrentProjectId(task.projectId);
    setFilter('all');
    navigate('/tasks');
    setTimeout(() => {
      const el = document.getElementById(`task-${task.id}`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="fixed top-4 right-4 w-80 z-50 bg-white dark:bg-slate-800 rounded-xl shadow-lg border border-slate-200 dark:border-slate-700"
        >
          <div className="flex items-center justify-between p-3 border-b border-slate-200 dark:border-slate-700">
            <h3 className="text-sm font-semibold text-slate-800 dark:text-white">Due Tasks</h3>
            <button
              onClick={() => setVisible(false)}
              className="text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
            >
              <SafeIcon icon={FiX} />
            </button>
          </div>
          <div className="p-3 space-y-4 max-h-64 overflow-y-auto">
            {dueToday.length > 0 && (
              <div>
                <div className="flex items-center gap-2 text-sm font-medium text-blue-600 dark:text-blue-400 mb-1">
                  <SafeIcon icon={FiCalendar} />
                  <span>Due today</span>
                </div>
                <ul className="space-y-1">
                  {dueToday.map(task => (
                    <li key={task.id}>
                      <button
                        onClick={() => openTask(task)}
                        className="w-full text-left text-sm text-slate-700 dark:text-slate-300 hover:underline flex items-center justify-between"
                      >
                        <span className="truncate">{task.title}</span>
                        <SafeIcon icon={FiArrowRight} className="text-xs" />
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {overdue.length > 0 && (
              <div>
                <div className="flex items-center gap-2 text-sm font-medium text-red-600 dark:text-red-400 mb-1">
                  <SafeIcon icon={FiAlertTriangle} />
                  <span>Overdue</span>
                </div>
                <ul className="space-y-1">
                  {overdue.map(task => (
                    <li key={task.id}>
                      <button
                        onClick={() => openTask(task)}
                        className="w-full text-left text-sm text-slate-700 dark:text-slate-300 hover:underline flex items-center justify-between"
                      >
                        <span className="truncate">{task.title}</span>
                        <SafeIcon icon={FiArrowRight} className="text-xs text-red-600 dark:text-red-400" />
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DueTasksNotification;
